import React from "react"
import WithChildren from "../models/interfaces"

export interface ContainerProps extends WithChildren {
    fluid?: boolean
}

export class Container extends React.Component<ContainerProps, any> {
    render() {
        const className = this.props.fluid ? "container-fluid" : "container"
        return <div className={className}>{this.props.children}</div>
    }
}
